import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AuthComponent, SafeHtmlPipe} from './auth.component';
import {RouterModule} from '@angular/router';
import {AuthenticationService} from '../../_services/authentication.service';
import {InterceptorService} from 'ng2-interceptors';
import {HttpModule, RequestOptions, XHRBackend} from '@angular/http';
import {ServerURLInterceptor} from '../../_models/interceptor';
import {SocialAuthService} from '../../_services/socialAuth.service';
import {SharedModule} from '../../_shared/shared.module';

export function interceptorFactory(xhrBackend: XHRBackend, requestOptions: RequestOptions, serverURLInterceptor: ServerURLInterceptor) {
  const service = new InterceptorService(xhrBackend, requestOptions);
  service.addInterceptor(serverURLInterceptor); // Add it here
  return service;
}

@NgModule({
  imports: [
    SharedModule,
    HttpModule,
    RouterModule.forChild([
      {
        path: '',
        data: {
          title: 'Auth'
        },
        component: AuthComponent
      }
    ]),
  ],
  declarations: [AuthComponent, SafeHtmlPipe],
  bootstrap: [AuthComponent],
  providers: [
    SocialAuthService,
    AuthenticationService,
    ServerURLInterceptor,
    {
      provide: InterceptorService,
      useFactory: interceptorFactory,
      deps: [XHRBackend, RequestOptions, ServerURLInterceptor]
    }]
})
export class AuthModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/auth/auth.module.ts